"use client";
import { UserWithCompanies } from "@/components/auth";
import { useAppStore, selectUser } from "@/store/appStore";
import { BankAccount } from "@prisma/client";
import type { AccountExtended } from "@/types/account-extended.type";
import { FC, useState } from "react";
import { CloudUploadIcon } from "lucide-react";
import { Plus } from "lucide-react";
import { UploadsProps } from "./uploads.types";
import { Content } from "../components/page/components";
import { ContentHeader } from "../components";
import { List } from "../components/list";
import { CurrencyCode, MenuItem } from "@/components/ui";
import IBAN from "iban";

const Uploads: FC<UploadsProps> = () => {
  const user = useAppStore(selectUser);
  const accounts =
    user?.selectedCompany?.bankAccounts
      ?.slice()
      .sort((a: AccountExtended, b: AccountExtended) => {
        return (
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      }) || [];
  const [selected, setSelected] = useState<BankAccount | undefined>(
    accounts[0]
  );

  return (
    user &&
    accounts && (
      <>
        <Content>
          <ContentHeader
            datePicker={false}
            title={{
              value: "Uploads",
              icon: CloudUploadIcon,
              align: "left",
            }}
            actions={[
              {
                icon: Plus,
                text: "Connect Account",
              },
            ]}
          />
          <List
            groupBy={(account) => account.institution.name}
            sortGroupBy={(a, b) => (a && b ? a.localeCompare(b) : 0)}
            title={(account) => {
              return (
                <MenuItem
                  label={account.institution.name}
                  image={{
                    type: "avatar",
                    source: account.institution.logo,
                    fallback: account.institution.name
                      ? account.institution.name.charAt(0)
                      : "",
                  }}
                  className="flex flex-row items-center"
                />
              );
            }}
            items={accounts.map((account: AccountExtended) => ({
              label: account.iban
                ? IBAN.printFormat(account.iban)
                : account.bban
                ? IBAN.printFormat(account.bban)
                : undefined,
              description: account.currency || undefined,
              amount: account.balance ?? undefined,
              currency: account.currency as CurrencyCode,
              isSelected: selected?.id === account.id,
              //status: 'COMPLETED', //TODO: Dynamic Workflow Status
              onClick: () => {
                console.log("account clicked", account);
                setSelected(account);
              },
              image: {
                type: "currency",
                source: account.currency || undefined,
                size: "L",
                fallback: account.institution.name
                  ? account.institution.name.slice(0, 2).toUpperCase()
                  : "N/A",
              },
              institution: account.institution,
            }))}
          />
        </Content>

        {/*selected && (
        <StatementContextPanel statement={selected} />
        )*/}
      </>
    )
  );
};

export { Uploads };
